import React, {
  useState,
  useRef,
  useEffect,
} from "react";

import {
  FaSearch,
  FaBars,
  FaWhatsapp,
} from "react-icons/fa";

import { useNavigate } from "react-router-dom";
import logo from "../assets/logo.png";
import { Link } from "react-router-dom";

const Header = ({ toggleSidebar }) => {
  const [open, setOpen] =
    useState(false);

  const [search, setSearch] =
    useState("");

  const ref = useRef();

  const navigate =
    useNavigate();

  useEffect(() => {
    const handleClick = (e) => {
      if (
        ref.current &&
        !ref.current.contains(
          e.target
        )
      ) {
        setOpen(false);
      }
    };

    document.addEventListener(
      "mousedown",
      handleClick
    );

    return () =>
      document.removeEventListener(
        "mousedown",
        handleClick
      );
  }, []);

  /* SEARCH FUNCTION */
  const handleSearch = () => {
    const text =
      search
        .toLowerCase()
        .trim();

    if (!text) return;

    if (
      text.includes("home")
    ) {
      navigate("/");
    } else if (
      text.includes("about")
    ) {
      navigate("/about");
    } else if (
      text.includes("gallery")
    ) {
      navigate("/gallery");
    } else if (
      text.includes("news")
    ) {
      navigate("/news");
    } else if (
      text.includes("event")
    ) {
      navigate("/events");
    } else if (
      text.includes("contact")
    ) {
      navigate("/contact");
    } else if (
      text.includes("cbse")
    ) {
      navigate("/cbse-documents");
    } else if (
      text.includes("student tc") ||
      text.includes("tc")
    ) {
      navigate("/student-tc");
    } else if (
      text.includes("infrastructure")
    ) {
      navigate("/infrastructure");
    } else if (
      text.includes(
        "notice"
      ) ||
      text.includes(
        "notices"
      )
    ) {
      navigate(
        "/notices/1"
      );
    } else if (
      text.includes(
        "document"
      ) ||
      text.includes(
        "pdf"
      ) ||
      text.includes(
        "zip"
      )
    ) {
      navigate(
        "/documents"
      );
    } else if (
      text.includes(
        "admission"
      )
    ) {
      navigate("/");

      setTimeout(() => {
        const el =
          document.getElementById(
            "admission"
          );

        if (el) {
          el.scrollIntoView(
            {
              behavior:
                "smooth",
              block:
                "start",
            }
          );
        }
      }, 400);
    } else {
      alert(
        "Search result not found ❌"
      );
    }

    setSearch("");
    setOpen(false);
  };

  return (
    <>
      <header className="sticky top-0 z-50 bg-white shadow-md border-b border-gray-200">

        <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between gap-4">

          {/* LEFT */}
          <div className="flex items-center gap-4">

            {/* LOGO */}
            <Link to="/">
              <img
                src={logo}
                alt="School Logo"
                className="h-16 md:h-24 object-contain"
              />
            </Link>

            {/* SCHOOL NAME */}
            <div className="hidden sm:block">

              <h1 className="text-[#072F5F] text-2xl md:text-5xl font-bold leading-tight">

                ST. JOSEPH'S SCHOOL

              </h1>

              <p className="text-gray-600 text-sm md:text-lg mt-1">

                Maharajganj, UP - 273303

              </p>

            </div>

          </div>

          {/* RIGHT */}
          <div className="flex items-center gap-2 md:gap-4">

            {/* Virtual Tour */}
            <button
              className="hidden md:flex bg-[#0B4F9C] hover:bg-[#072F5F] text-white px-4 py-2 rounded-lg font-medium transition-all duration-300"
              onClick={() =>
                navigate(
                  "/virtual-tour"
                )
              }
            >
              Virtual Tour
            </button>

            {/* STUDENT TC */}
            <button
              className="hidden md:flex bg-[#D4A017] hover:bg-yellow-600 text-white px-4 py-2 rounded-lg font-medium transition-all duration-300"
              onClick={() =>
                navigate(
                  "/student-tc"
                )
              }
            >
              STUDENT TC
            </button>

            <button
              className="hidden md:flex bg-[#0B4F9C] hover:bg-[#072F5F] text-white px-4 py-2 rounded-lg font-medium transition-all duration-300"
              onClick={() =>
                navigate(
                  "/alumni"
                )
              }
            >
              Alumni
            </button>

            {/* WHATSAPP */}
            <a
              href="https://wa.me/7398973880"
              target="_blank"
              rel="noreferrer"
              title="WhatsApp"
              className="bg-green-500 hover:bg-green-600 text-white p-3 rounded-lg transition-all duration-300"
            >
              <FaWhatsapp className="text-lg" />
            </a>

            {/* SEARCH */}
            {/* <button
              className="bg-black hover:bg-gray-800 text-white p-3 rounded-lg transition-all duration-300"
              onClick={() =>
                setOpen(!open)
              }
            >
              <FaSearch />
            </button> */}

            {/* MENU */}
            <button
              className="bg-[#0B4F9C] hover:bg-[#072F5F] text-white px-4 py-3 rounded-lg flex items-center gap-2 font-medium transition-all duration-300"
              onClick={
                toggleSidebar
              }
            >
              <span className="hidden sm:block">
                MENU
              </span>

              <FaBars />
            </button>

          </div>
        </div>
      </header>

      {/* SEARCH BOX */}
      {open && (
        <div
          className="absolute top-24 right-4 z-50 w-[90%] sm:w-[400px]"
          ref={ref}
        >
          <div className="bg-white shadow-2xl rounded-2xl p-4 border border-gray-200">

            <div className="flex items-center gap-2">

              <input
                type="text"
                placeholder="Search..."
                value={search}
                onChange={(e) =>
                  setSearch(
                    e.target.value
                  )
                }
                onKeyDown={(e) =>
                  e.key ===
                  "Enter" &&
                  handleSearch()
                }
                className="flex-1 border border-gray-300 rounded-xl px-4 py-3 outline-none focus:ring-2 focus:ring-[#0B4F9C]"
              />

              <button
                className="bg-[#0B4F9C] hover:bg-[#072F5F] text-white p-3 rounded-xl transition-all duration-300"
                onClick={
                  handleSearch
                }
              >
                <FaSearch />
              </button>

            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Header;